import type { EngagementBudgetHeader, EngagementBudgetTree } from "@models/engagementBudgetTree.model"
import { CommandGetEngagementBudget } from "./commands/cmdGetEngagementBudget"
import { CommandGetEngagementBudgetTree } from "./commands/cmdGetEngagementBudgetTree"
import {
  CommandUpsertEngagementLaunchPolicy,
  EngagementLaunchPolicyPayload,
} from "./commands/cmdUpsertEngagementLaunchPolicy"
import {
  CommandSaveLaunchBudget,
  LaunchBudgetSavePayload,
} from "./commands/cmdSaveLaunchBudget"
import { CommandMigrateLaunchBudget } from "./commands/cmdMigrateLaunchBudget"
import { CommandDeleteEngagementLaunchPolicy } from "./commands/cmdDeleteEngagementLaunchPolicy"
import {
  CommandUpsertLaunchNetworkPolicy,
  LaunchNetworkPolicyPayload,
} from "./commands/cmdUpsertLaunchNetworkPolicy"
import { CommandDeleteLaunchNetworkPolicy } from "./commands/cmdDeleteLaunchNetworkPolicy"
import {
  CommandUpsertAudienceNetworkPolicy,
  AudienceNetworkPolicyPayload,
} from "./commands/cmdUpsertAudienceNetworkPolicy"
import { CommandDeleteAudienceNetworkPolicy } from "./commands/cmdDeleteAudienceNetworkPolicy"

export class EngagementBudgetService {
  async getHeader(engagementId: number): Promise<EngagementBudgetHeader> {
    return await new CommandGetEngagementBudget().run(engagementId)
  }

  async getTree(engagementId: number): Promise<EngagementBudgetTree> {
    return await new CommandGetEngagementBudgetTree().run(engagementId)
  }

  /** Commit a campaign's whole budget draft as a unit (MPN-1802). */
  async saveLaunchBudget(launchId: number, payload: LaunchBudgetSavePayload): Promise<void> {
    return await new CommandSaveLaunchBudget().run(launchId, payload)
  }

  /** Move a legacy campaign onto spend windows, once (MPN-1803). */
  async migrateLaunchBudget(launchId: number): Promise<void> {
    return await new CommandMigrateLaunchBudget().run(launchId)
  }

  async setLaunchPolicy(engagementId: number, payload: EngagementLaunchPolicyPayload): Promise<void> {
    return await new CommandUpsertEngagementLaunchPolicy().run(engagementId, payload)
  }

  async clearLaunchPolicy(engagementId: number, launchId: number): Promise<void> {
    return await new CommandDeleteEngagementLaunchPolicy().run(engagementId, launchId)
  }

  async setNetworkPolicy(launchId: number, payload: LaunchNetworkPolicyPayload): Promise<void> {
    return await new CommandUpsertLaunchNetworkPolicy().run(launchId, payload)
  }

  async clearNetworkPolicy(launchId: number, network: string): Promise<void> {
    return await new CommandDeleteLaunchNetworkPolicy().run(launchId, network)
  }

  async setAudiencePolicy(
    launchId: number,
    adGroupId: number,
    payload: AudienceNetworkPolicyPayload,
  ): Promise<void> {
    return await new CommandUpsertAudienceNetworkPolicy().run(launchId, adGroupId, payload)
  }

  async clearAudiencePolicy(launchId: number, adGroupId: number, network: string): Promise<void> {
    return await new CommandDeleteAudienceNetworkPolicy().run(launchId, adGroupId, network)
  }
}
